import { PrimeIcons } from "primereact/api";

import { labelError } from "_constants";
import { Tag } from "primereact/tag";

export const StateSourceError = (onClickCallback: Function) => {
  return (
    <Tag
      className="mr-2 source-error "
      icon={PrimeIcons.EXCLAMATION_TRIANGLE}
      severity="danger"
      value={labelError}
      onClick={() => onClickCallback()}
    />
  );
};
